<app-loading-spinner [isLoading]="daveningService.loading()"></app-loading-spinner>

<div *ngIf="!sent">
    <h2 class="text-center">Are you ready to send out the list?</h2>
    <h4 class="text-center">Please enter the admin password to proceed:</h4>
    <div class="row">
        <div class="col-2 offset-5">
            <form [formGroup]="sendForm" (ngSubmit)="onSubmit()">
                <div class="form-group">
                    <label for="password">Password</label>
                    <input type="password" id="password" formControlName="password" class="form-control">
                    <span span *ngIf="!sendForm.get('password')?.valid && sendForm.get('password')?.touched"
                        class="help-block">Password is required</span>
                </div>

                <div class="form-group text-center">
                    <button type="submit" class="btn btn-success" [disabled]="!sendForm.valid">Send</button>
                </div>
            </form>
        </div>
    </div>
</div>

<div *ngIf="sent" class="text-center">
    <button class="btn btn-info btn-lg btn-website" (click)="goToWebsite()">Take me to the website</button>
</div>